import { render, staticRenderFns } from "./customerAddressBook.vue?vue&type=template&id=5efc4116&scoped=true"
import script from "./customerAddressBook.vue?vue&type=script&lang=js"
export * from "./customerAddressBook.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=5efc4116&prod&scoped=true&lang=css&external"
import style1 from "./customerAddressBook.vue?vue&type=style&index=1&id=5efc4116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc4116",
  null
  
)

export default component.exports